import { render, staticRenderFns } from "./upgradePrizeList.vue?vue&type=template&id=5b5f88ba&scoped=true&"
import script from "./upgradePrizeList.vue?vue&type=script&lang=js&"
export * from "./upgradePrizeList.vue?vue&type=script&lang=js&"
import style0 from "./upgradePrizeList.vue?vue&type=style&index=0&id=5b5f88ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5f88ba",
  null
  
)

export default component.exports